<body class="bg-transparent">
  <!-- Everything in this block is CHROME: it describes the signed-in session. It is suppressed wholesale on the
       authentication routes (IsChromeFree — see chrome-free-routes.ts), for two reasons that are really one:
       an invitee opening a forwarded link must not be shown whoever last used this browser, and the handoff
       landing must not fire these components' bootstrap calls with a session the provider callback has already
       superseded (their 401s are what logged a successful sign-in straight back out). -->
  @if (!IsChromeFree()) {
    <app-impersonation-banner></app-impersonation-banner>
    <!-- Context switcher (#279): WHERE this account works, bottom left. The only session switcher left — the
         bottom-right ACCOUNT switcher is gone, because a grant-scoped context is now the way a session reaches a
         company/shard. Renders nothing unless there is more than one place to be.
         `placement="floating"` is the historical corner pill, and it is on screen from Tailwind's `sm` upwards
         only (#602). Below that width the very same component renders as a chip inside each shell's own top bar
         — `navbar-office` and the employee panel declare it there — because the corner is where a phone keeps
         its dialog footers, its drawer and the installed app's tab bar. Exactly one of the declarations is in
         the DOM at a time; they share one fetch through `ContextOptionsStore`. -->
    <auth-context-switcher placement="floating"/>
  }
  @if (IsLoggedIn() && !IsSelfService() && !IsChromeFree()) {
    <!-- if user is logged in -->
    @if (IsOperator()) {
      <!-- if user is an operator (#205) — its own branch, deliberately ahead of the employee one.
           The Operator shell (app-operator-panel) draws its own 56 px (h-14) top bar and positions its rail and
           content itself, so this branch must NOT contribute the employee panel's pt-10 / lg:pt-20 offset: that
           padding is sized for the employee navbar and would sit anything laid out in normal flow 24 px below
           the Operator's own bar. The box below starts flush underneath that bar; it is only the fallback
           container, because the shell's own chrome is fixed-positioned and does not depend on it. The alert
           banner is fixed too and takes its offset from AlertBannerComponent.TopOffsetClass, not from here. -->
      <main class="absolute inset-x-0 top-14 bottom-0 overflow-y-auto" #relative
            [ngClass]="{'!bottom-14': authenticationService.isImpersonating}">
        <app-alert-banner class=""></app-alert-banner>
        <router-outlet></router-outlet>
      </main>
    } @else if (isEmployee) {
      <!-- if user is employee -->
      <main class="absolute pt-10 lg:pt-20 inset-0 overflow-y-auto !px-4 lg:!px-8" #relative
            [ngClass]="{'!bottom-14': authenticationService.isImpersonating}">
        <app-alert-banner class=""></app-alert-banner>
        <router-outlet></router-outlet>
      </main>
    } @else {
      <!-- if user is not employee -->
      <app-navbar-office></app-navbar-office>
      <main>
        <!-- overflow-x-hidden: the page content area scrolls only vertically. Wide content (e.g. data tables)
             must scroll inside its own overflow-x-auto wrapper — otherwise a scroll container's min-content
             leaks here and the WHOLE PAGE scrolls sideways at large-but-not-max widths (#140). -->
        <div class="fixed top-14 bottom-0 inset-x-0 transition-[top] py-8 px-2 lg:!p-8 overflow-y-auto overflow-x-hidden" #relative
             [ngClass]="{'!top-[9.5rem]': NavbarService.hasExpanded(), '!bottom-14': authenticationService.isImpersonating}"> <!-- px-4 sm:px-6 lg:px-8 -->
          <app-alert-banner class=""></app-alert-banner>
          <router-outlet></router-outlet>
        </div>
      </main>
      <app-help-integration></app-help-integration>
    }
  } @else {
    <!-- if user is not logged in or self-service -->
    <main #relative>
      <app-alert-banner class=""></app-alert-banner>
      <router-outlet></router-outlet>
    </main>
  }

<!-- Migration notice (#279). Outside both shell branches on purpose: it applies to every signed-in legacy
     session, whether that renders the admin chrome or a panel shell. Renders nothing unless the session is
     legacy — but it asks /auth/migration/status to find out, so it belongs behind IsChromeFree with the rest.
     Sign-in notice (#279): what an external sign-in wanted to say once the person is INSIDE. The handoff
     landing is not inside — SigningInComponent deliberately forwards the notice to the page the session
     actually reaches — so announcing it on the loader would say it twice, once to a screen nobody stays on. -->
@if (!IsChromeFree()) {
  <auth-migration-notice-host/>
  <auth-sign-in-notice/>
}

<app-fullscreen-loader [show]="LoadingIndicatorService.loading"/>
  @if (keyboardService.isOptionPressed) {
    <app-info-message message="Links werden in neuem Tab geöffnet"/>
  }
<app-cookie-settings/>
</body>
